
import classes from "./HomeNavbar.module.css"

const HomeNavbar = () => {
    return (
        <div className={classes.navbar_body}>
            <h1 className={classes.navbar_text}>Benjamin Faber</h1>
        </div>
    )
}

export default HomeNavbar;